import React from 'react';
import { Paper, Grid, Box, Typography } from '@material-ui/core';

import useStyles from './styles';

import useCar from '../../../../context/useCar';
import { useIsDesktop } from 'components/utilities';

const CarDetailsHeader = ({ boxSizes }) => {
	const classes = useStyles();

	const {
		carDetails: { car },
	} = useCar();

	const isDesktop = useIsDesktop();

	return (
		<Paper>
			<Box {...boxSizes}>
				<Grid container spacing={5} justify="space-between">
					<Grid item xs={12} md={6}>
						<Grid
							container
							spacing={2}
							justify="space-between"
							className={classes.carHeaderWrapper}
							direction={isDesktop ? 'column' : 'row'}
						>
							<Grid item xs={6}>
								<Typography
									variant="h2"
									className={isDesktop ? classes.carName : null}
								>
									{car.name}
								</Typography>
								<Typography variant="h4" className={classes.carName}>
									{car.year}
								</Typography>
							</Grid>

							<Grid
								item
								xs={6}
								container
								alignItems="flex-end"
								justify="flex-end"
								className={classes.officeWrapper}
							>
								<Grid item>
									<img
										src={car.office.logo}
										alt={car.office.name}
										className={
											isDesktop ? classes.officeImage : classes.officeImageSmall
										}
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12} md={6}>
						<img src={car.image} alt={car.name} className={classes.carImage} />
					</Grid>
				</Grid>
			</Box>
		</Paper>
	);
};

export default CarDetailsHeader;
